import {Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {DocumentStatusesEnum} from 'app/main/pages/documents/dto/document-statuses.enum';
import {RecipientRoleDetail} from '../main/pages/documents/dto/document-details.dto';
import {Personfield} from '../main/signing-pages/verification-page/verification-page-dto';
import {GetRecipientPipe} from './get-recipient.pipe';

@Pipe({
  name: 'sentTo'
})
export class SentToPipe implements PipeTransform {

  constructor (private _translocoService$: TranslocoService) {}

  transform(value: { recipient_role_detail: RecipientRoleDetail, person: Personfield[] }[]) {
    const person = [];
    const getRecipient = new GetRecipientPipe(this._translocoService$);
    for (const recipient_role of value) {
      if(recipient_role?.recipient_role_detail?.status != DocumentStatusesEnum.Waiting){
        const recipient = getRecipient.transform( recipient_role.person);
        person.push({ name: recipient });
      }
    }
    const items = person.map(item => item['name']);
    if (items.length === 1) {
      return items.join(', '); // Return the single item without ' & '
    } else {
      const lastItem = items.pop();
      return items.join(', ') + ' & ' + lastItem;
    }
  }

}
